import styled from 'styled-components'

export const Container = styled.div``

export const Subheader = styled.div`
  height: 126px;
  width: 100%;

  position: relative;

  background: var(--blue00);
  background: linear-gradient(90deg, rgba(0,105,182,1) 0%, rgba(0,120,208,1) 10%);

  .web-profile__subheader-button{
    width: fit-content;
    height: 20px;

    position: absolute;
    top: calc(50% - 10px);
    left: 222.1px;

    border: 0;
    outline: none;
    background: transparent;
    cursor: pointer;
    transition: filter 0.3s;

    &:hover{
      filter: brightness(1.1);
    }
  }

  .web-profile__subheader-icon{
    height: 20px;
    width: auto;
    stroke: #fff;
  }

  @media (max-width: 1170px){
    .web-profile__subheader-button{
      top: calc(30% - 10px);
      left: 20px;
    }
  }
`

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 0 0 45.4px;

  @media (max-width: 1170px){
    width: 100%;
    margin: 0 0 50px 0;
  }
`

export const Section = styled.section`
  width: 100%;
  height: fit-content;
  margin-top: -93px;

  display: flex;
  flex-direction: column;
  align-items: center;

  .web-profile__section__title{
    font-size: 2rem;
    color: var(--blue00);
  }

  .web-profile__section__form{
    width: 90%;
    max-width: 453.55px;
    height: fit-content;
    margin-top: 23.2px;
    padding: 36.5px 0 34.5px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    border-radius: 38px;
    background-color: var(--bluef0);
  }

  .web-profile__section__form-input-wrapper{
    width: 80%;
    height: fit-content;
    margin: 0 auto 34.4px;
  }

  .web-profile__section__form-label,
  .personal-profile__section__form-input-readonly,
  .personal-profile__section__form-input{
    width: 100%;

    display: block;
  }

  .web-profile__section__form-label{
    margin-bottom: 18.2px;

    font-size: 1.3125rem;
    color: var(--blue00);
  }

  .personal-profile__section__form-input-readonly,
  .personal-profile__section__form-input{
    height: 47.02px;
    margin-top: 7.4px;
    padding: 0 23.7px;

    color: var(--grayad);
    font-size: 1rem;
    border: 0;
    outline: none;
    border-radius: 19px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.15);
  }

  .personal-profile__section__form-input-readonly{
    margin-bottom: 15px;
  }

  .web-profile__section__form-button{
    width: 80%;
    height: 48.26px;
    margin: 7.4px auto 0;

    border: 0;
    border-radius: 38px;
    background-color: var(--blue00);
    font-size: 1.0625rem;
    color: #fff;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    cursor: pointer;
    transition: filter 0.3s, opacity 0.3s;

    &:not(:disabled):hover {
      filter: brightness(1.1);
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
`
